<div
  class="tab-menu-list"
  #tabMenuList
  [ngClass]="menuStyle()"
  cdkDropList
  cdkDropListOrientation="horizontal"
  [cdkDropListDisabled]="!isDraggable()"
  [cdkDropListSortPredicate]="sortPredicate.bind(this)"
  (cdkDropListDropped)="drop($event)"
>
  @for (item of internalMenuItems(); track item.title) {
    @if (item.url) {
      @if (item.permission) {
        <div>
          <twc-tab-menu-link-wrapper
            *permission="item.permission"
            class="tab-menu-item"
            cdkDrag
            [cdkDragData]="item"
            [cdkDragDisabled]="!item.draggable"
            [item]="item"
            [menuStyle]="menuStyle()"
            [menuItemArgument]="menuItemArgument()"
            [queryParamHandling]="queryParamHandling()"
            [replaceURL]="replaceURL()"
            (itemClick)="setActiveItem($event)"
          />
        </div>
      } @else {
        <twc-tab-menu-link-wrapper
          class="tab-menu-item"
          cdkDrag
          [cdkDragDisabled]="!item.draggable"
          [cdkDragData]="item"
          [item]="item"
          [menuStyle]="menuStyle()"
          [menuItemArgument]="menuItemArgument()"
          [queryParamHandling]="queryParamHandling()"
          [replaceURL]="replaceURL()"
          (itemClick)="setActiveItem($event)"
        />
      }
    }
    @if (item.clickFn) {
      @if (item.permission) {
        <twc-tab-menu-button-link-wrapper
          *permission="item.permission"
          class="tab-menu-item"
          cdkDrag
          [cdkDragData]="item"
          [cdkDragDisabled]="!item.draggable"
          [item]="item"
          [menuStyle]="menuStyle()"
          [menuItemArgument]="menuItemArgument()"
          (itemClick)="onItemClick($event)"
        />
      } @else {
        <twc-tab-menu-button-link-wrapper
          class="tab-menu-item"
          cdkDrag
          [cdkDragDisabled]="!item.draggable"
          [cdkDragData]="item"
          [item]="item"
          [menuStyle]="menuStyle()"
          [menuItemArgument]="menuItemArgument()"
          (itemClick)="onItemClick($event)"
        />
      }
    }
  }
  @if (overflowItems().length) {
    <twc-tab-menu-more-button
      [overflowItems]="overflowItems()"
      [menuStyle]="menuStyle()"
      (overflowItemSelected)="overflowItemSelected($event)"
    />
  }
</div>
